import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useCallback, useEffect, useMemo } from "react";
import { nextLetterInAlphabet } from "utils/Utils";

interface ReorderButtonGroupProps {
  prevValue?: string;
  fileId: number;
  changeFileNames: (fileId: number, value: string) => void;
  selectedValue?: string;
  index: number;
}

export const ReorderButtonGroup = ({
  index,
  selectedValue,
  fileId,
  prevValue,
  changeFileNames,
}: ReorderButtonGroupProps) => {
  const options = useMemo(() => {
    if (index === 0) {
      return ["1", "1-a"];
    }
    const valueLength = prevValue?.length;

    if (valueLength === 1) {
      const number = Number(prevValue);
      return [`${number}-a`, `${number + 1}`, `${number + 1}-a`];
    } else if (valueLength === 3) {
      const [numberChar, letterChar] = prevValue!.split("-");
      const numberValue = Number(numberChar);
      return [`${numberValue}-${nextLetterInAlphabet(letterChar)}`, `${numberValue + 1}`, `${numberValue + 1}-a`];
    }
    return [];
  }, [index, prevValue]);

  const handleOptionChange = useCallback(
    (option: string) => {
      changeFileNames(fileId, option);
    },
    [fileId, changeFileNames]
  );

  useEffect(() => {
    if (selectedValue && !options.includes(selectedValue) && prevValue) {
      changeFileNames(fileId, options[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue, options]);

  return (
    <Autocomplete
      options={options}
      onChange={(event, newValue) => handleOptionChange(newValue as string)}
      value={selectedValue}
      getOptionLabel={(option: any) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          margin="normal"
          name="fileTitle"
          label="File title"
          fullWidth
        />
      )}
    />
  );
};
